"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ActionMessage_1 = __importDefault(require("@/Jetstream/ActionMessage"));
var ActionSection_1 = __importDefault(require("@/Jetstream/ActionSection"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var Checkbox_1 = __importDefault(require("@/Jetstream/Checkbox"));
var ConfirmationModal_1 = __importDefault(require("@/Jetstream/ConfirmationModal"));
var DangerButton_1 = __importDefault(require("@/Jetstream/DangerButton"));
var DialogModal_1 = __importDefault(require("@/Jetstream/DialogModal"));
var FormSection_1 = __importDefault(require("@/Jetstream/FormSection"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var InputError_1 = __importDefault(require("@/Jetstream/InputError"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var SecondaryButton_1 = __importDefault(require("@/Jetstream/SecondaryButton"));
var SectionBorder_1 = __importDefault(require("@/Jetstream/SectionBorder"));
function APITokenManager(_a) {
    var _b, _c, _d;
    var tokens = _a.tokens, availablePermissions = _a.availablePermissions, defaultPermissions = _a.defaultPermissions;
    var route = (0, useRoute_1.default)();
    var createApiTokenForm = (0, inertia_react_1.useForm)({
        name: '',
        permissions: defaultPermissions,
    });
    var updateApiTokenForm = (0, inertia_react_1.useForm)({
        permissions: [],
    });
    var deleteApiTokenForm = (0, inertia_react_1.useForm)({});
    var _e = (0, react_1.useState)(false), displayingToken = _e[0], setDisplayingToken = _e[1];
    var _f = (0, react_1.useState)(null), managingPermissionsFor = _f[0], setManagingPermissionsFor = _f[1];
    var _g = (0, react_1.useState)(null), apiTokenBeingDeleted = _g[0], setApiTokenBeingDeleted = _g[1];
    var page = (0, inertia_react_1.usePage)();
    function createApiToken() {
        createApiTokenForm.post(route('api-tokens.store'), {
            preserveScroll: true,
            onSuccess: function () {
                setDisplayingToken(true);
                createApiTokenForm.reset();
            },
        });
    }
    function manageApiTokenPermissions(token) {
        updateApiTokenForm.setData('permissions', token.abilities);
        setManagingPermissionsFor(token);
    }
    function updateApiToken() {
        if (!managingPermissionsFor) {
            return;
        }
        updateApiTokenForm.put(route('api-tokens.update', [managingPermissionsFor]), {
            preserveScroll: true,
            preserveState: true,
            onSuccess: function () { return setManagingPermissionsFor(null); },
        });
    }
    function confirmApiTokenDeletion(token) {
        setApiTokenBeingDeleted(token);
    }
    function deleteApiToken() {
        if (!apiTokenBeingDeleted) {
            return;
        }
        deleteApiTokenForm.delete(route('api-tokens.destroy', [apiTokenBeingDeleted]), {
            preserveScroll: true,
            preserveState: true,
            onSuccess: function () { return setApiTokenBeingDeleted(null); },
        });
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(FormSection_1.default, { onSubmit: createApiToken, title: 'Create API Token', description: 'API tokens allow third-party services to authenticate with our application on your behalf.', renderActions: function () { return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ActionMessage_1.default, { on: createApiTokenForm.recentlySuccessful, className: "mr-3" }, "Created."),
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)({
                        'opacity-25': createApiTokenForm.processing,
                    }), disabled: createApiTokenForm.processing }, "Create"))); } },
            react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "name" }, "Name"),
                react_1.default.createElement(Input_1.default, { id: "name", type: "text", className: "mt-1 block w-full", value: createApiTokenForm.data.name, onChange: function (e) {
                        return createApiTokenForm.setData('name', e.currentTarget.value);
                    }, autoFocus: true }),
                react_1.default.createElement(InputError_1.default, { message: createApiTokenForm.errors.name, className: "mt-2" })),
            availablePermissions.length > 0 && (react_1.default.createElement("div", { className: "col-span-6" },
                react_1.default.createElement(Label_1.default, { htmlFor: "permissions" }, "Permissions"),
                react_1.default.createElement("div", { className: "mt-2 grid grid-cols-1 md:grid-cols-2 gap-4" }, availablePermissions.map(function (permission) { return (react_1.default.createElement("div", { key: permission },
                    react_1.default.createElement("label", { className: "flex items-center" },
                        react_1.default.createElement(Checkbox_1.default, { value: permission, checked: createApiTokenForm.data.permissions.includes(permission), onChange: function (e) {
                                if (createApiTokenForm.data.permissions.includes(e.currentTarget.value)) {
                                    createApiTokenForm.setData('permissions', createApiTokenForm.data.permissions.filter(function (p) { return p !== e.currentTarget.value; }));
                                }
                                else {
                                    createApiTokenForm.setData('permissions', __spreadArray([
                                        e.currentTarget.value
                                    ], createApiTokenForm.data.permissions, true));
                                }
                            } }),
                        react_1.default.createElement("span", { className: "ml-2 text-sm text-gray-600" }, permission)))); }))))),
        tokens.length > 0 ? (react_1.default.createElement("div", null,
            react_1.default.createElement(SectionBorder_1.default, null),
            react_1.default.createElement("div", { className: "mt-10 sm:mt-0" },
                react_1.default.createElement(ActionSection_1.default, { title: 'Manage API Tokens', description: 'You may delete any of your existing tokens if they are no longer needed.' },
                    react_1.default.createElement("div", { className: "space-y-6" }, tokens.map(function (token) { return (react_1.default.createElement("div", { className: "flex items-center justify-between", key: token.id },
                        react_1.default.createElement("div", null, token.name),
                        react_1.default.createElement("div", { className: "flex items-center" },
                            token.last_used_ago && (react_1.default.createElement("div", { className: "text-sm text-gray-400" },
                                "Last used ",
                                token.last_used_ago)),
                            availablePermissions.length > 0 ? (react_1.default.createElement("button", { className: "cursor-pointer ml-6 text-sm text-gray-400 underline", onClick: function () { return manageApiTokenPermissions(token); } }, "Permissions")) : null,
                            react_1.default.createElement("button", { className: "cursor-pointer ml-6 text-sm text-red-500", onClick: function () { return confirmApiTokenDeletion(token); } }, "Delete")))); })))))) : null,
        react_1.default.createElement(DialogModal_1.default, { isOpen: displayingToken, onClose: function () { return setDisplayingToken(false); } },
            react_1.default.createElement(DialogModal_1.default.Content, { title: 'API Token' },
                react_1.default.createElement("div", null, "Please copy your new API token. For your security, it won't be shown again."),
                react_1.default.createElement("div", { className: "mt-4 bg-gray-100 px-4 py-2 rounded font-mono text-sm text-gray-500" }, (_d = (_c = (_b = page.props) === null || _b === void 0 ? void 0 : _b.jetstream) === null || _c === void 0 ? void 0 : _c.flash) === null || _d === void 0 ? void 0 : _d.token)),
            react_1.default.createElement(DialogModal_1.default.Footer, null,
                react_1.default.createElement(SecondaryButton_1.default, { onClick: function () { return setDisplayingToken(false); } }, "Close"))),
        react_1.default.createElement(DialogModal_1.default, { isOpen: !!managingPermissionsFor, onClose: function () { return setManagingPermissionsFor(null); } },
            react_1.default.createElement(DialogModal_1.default.Content, { title: 'API Token Permissions' },
                react_1.default.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, availablePermissions.map(function (permission) { return (react_1.default.createElement("div", { key: permission },
                    react_1.default.createElement("label", { className: "flex items-center" },
                        react_1.default.createElement(Checkbox_1.default, { value: permission, checked: updateApiTokenForm.data.permissions.includes(permission), onChange: function (e) {
                                if (updateApiTokenForm.data.permissions.includes(e.currentTarget.value)) {
                                    updateApiTokenForm.setData('permissions', updateApiTokenForm.data.permissions.filter(function (p) { return p !== e.currentTarget.value; }));
                                }
                                else {
                                    updateApiTokenForm.setData('permissions', __spreadArray([
                                        e.currentTarget.value
                                    ], updateApiTokenForm.data.permissions, true));
                                }
                            } }),
                        react_1.default.createElement("span", { className: "ml-2 text-sm text-gray-600" }, permission)))); }))),
            react_1.default.createElement(DialogModal_1.default.Footer, null,
                react_1.default.createElement(SecondaryButton_1.default, { onClick: function () { return setManagingPermissionsFor(null); } }, "Cancel"),
                react_1.default.createElement(Button_1.default, { onClick: updateApiToken, className: (0, classnames_1.default)('ml-2', {
                        'opacity-25': updateApiTokenForm.processing,
                    }), disabled: updateApiTokenForm.processing }, "Save"))),
        react_1.default.createElement(ConfirmationModal_1.default, { isOpen: !!apiTokenBeingDeleted, onClose: function () { return setApiTokenBeingDeleted(null); } },
            react_1.default.createElement(ConfirmationModal_1.default.Content, { title: 'Delete API Token' }, "Are you sure you would like to delete this API token?"),
            react_1.default.createElement(ConfirmationModal_1.default.Footer, null,
                react_1.default.createElement(SecondaryButton_1.default, { onClick: function () { return setApiTokenBeingDeleted(null); } }, "Cancel"),
                react_1.default.createElement(DangerButton_1.default, { onClick: deleteApiToken, className: (0, classnames_1.default)('ml-2', {
                        'opacity-25': deleteApiTokenForm.processing,
                    }), disabled: deleteApiTokenForm.processing }, "Delete")))));
}
exports.default = APITokenManager;
